import portugueseMessages from "ra-language-pt-br";

export const alterPortuguese = {
  ...portugueseMessages,
  ra: {
    ...portugueseMessages.ra,
    message: {
      ...portugueseMessages.ra.message,
      clear_array_input: "Tem certeza que deseja limpar tudo?",
      // O texto da tradução da biblioteca tem erro de português ("seu
      // requisição") e fala em "navegador" — confunde o operador
      error:
        "A operação não pôde ser concluída. Tente novamente em instantes.",
    },
    page: {
      ...portugueseMessages.ra.page,
      error: "Não foi possível carregar esta tela",
    },
    action: {
      ...portugueseMessages.ra.action,
      back: "Voltar",
      select_columns: "Colunas",
      remove_all_filters: "Remover todos os filtros",
      save_current_query: "Salvar consulta atual",
      clear_array_input: "Limpar tudo",
      create_item: "Criar novo registro",
      move_up: "Mover para cima",
      move_down: "Mover para baixo",
    },
    configurable: {
      //   ...portugueseMessages.ra.configurable,
      customize: "Customizar",
    },
    saved_queries: {
      new_label: "Salvar consulta atual...",
      help: "Filtrar a lista e salvar essa consulta para mais tarde",
      label: "Consultas salvas",
      new_dialog_title: "Salvar consulta atual como",
      query_name: "Nome da consulta",
      remove_dialog_title: "Remover consulta salva?",
      remove_label: "Remover consulta salva",
      remove_label_with_name: 'Remover consulta "%{name}"',
      remove_message:
        "Tem certeza de que deseja remover esse item da sua lista de consultas salvas?",
    },
    // Avisos exibidos após salvar, criar, remover, etc.
    // O padrão da biblioteca fala em "Elemento" ("Elemento atualizado"),
    // que não diz nada para quem usa o painel.
    notification: {
      ...portugueseMessages.ra.notification,
      updated:
        "Alterações salvas |||| %{smart_count} registros atualizados",
      created: "Criado com sucesso",
      deleted: "Removido com sucesso |||| %{smart_count} registros removidos",
      bad_item: "Registro inválido",
      item_doesnt_exist: "Este registro não existe mais",
      http_error: "Não foi possível falar com o servidor. Tente novamente.",
      data_provider_error:
        "O servidor recusou a operação. Confira os dados e tente de novo.",
      canceled: "Ação cancelada",
      logged_out: "Sua sessão expirou. Entre novamente para continuar.",
      not_authorized: "Você não tem permissão para acessar isto.",
    },
  },
};
